import { useState, useEffect } from 'react';
import buildPBComponents from './helpers';

function usePageBuilder(data) {
  const [page, setPage] = useState([]);

  useEffect(
    () => {
      async function getBuiltComponents() {
        const components = buildPBComponents(data);

        setPage(components);
      }

      if (data && !page.length) {
        getBuiltComponents();
      }
    },
    [data, page]
  );

  return page;
}

export default usePageBuilder;
